import { State as AppState, FEEDBACK, STAFF, getAll, getEntities } from '../reducers/index';
import { createSelector } from 'reselect';
import { OrganisationFeedbackInterface } from '@careapp/angular-sdk';
export const getFeedbackState = (state: AppState) => state.auth;

export const feedbackWithMember = createSelector(
  getAll(FEEDBACK),
  getEntities(STAFF),
  (feedback, staff) => {
    return (<Array<OrganisationFeedbackInterface>>feedback).map(item => ({
      ...item,
      member: staff[item.memberId]
    }));
  }
);
